<template>
  <div v-if="bind.boolCarregado">
    <v-tabs v-model="strTab" centered icons-and-text>
      <v-tab href="#tab-cadastro">
        Configuração Geral
        <i :class="$utilidade.getIcone('cadastroGeral') + ' fa-2x'"></i>
      </v-tab>
      <v-tab href="#tab-block-horario">
        Bloquear Horários
        <i :class="$utilidade.getIcone('bloqueio') + ' fa-2x'"></i>
      </v-tab>
      <v-tab href="#tab-block-data">
        Bloquear Datas
        <i :class="$utilidade.getIcone('bloqueio') + ' fa-2x'"></i>
      </v-tab>
      <v-tab href="#tab-status">
        Gerenciar Status
        <i :class="$utilidade.getIcone('gerenciar') + ' fa-2x'"></i>
      </v-tab>
    </v-tabs>

    <ed-form
      :formData="formData.agendamentoConfiguracao.strValor"
      :handlerSave="strTab != 'tab-status' ? salvar : null"
      v-if="!this.$root.$session.loadingContent"
    >
      <cadastro-geral
        v-show="strTab == 'tab-cadastro'"
        :formData="formData"
        :key="'cadastro-geral-' + $root.$session.versao + strKey"
      />

      <bloquear-horario
        v-show="strTab == 'tab-block-horario'"
        :formData="formData"
        :key="'tab-block-horario-' + $root.$session.versao + strKey"
      />

      <bloquear-data
        v-show="strTab == 'tab-block-data'"
        :formData="formData"
        :key="'tab-block-data-' + $root.$session.versao + strKey"
      />

      <parametro
        v-show="strTab == 'tab-status'"
        strChave="agendamentoStatus"
        :key="'status-' + $root.$session.versao + strKey"
      />
    </ed-form>
  </div>
</template>

<script>
import Parametro from "@/components/common/parametro/editar";
import CadastroGeral from "./partials/geral.vue";
import BloquearHorario from "./partials/bloquearHorario.vue";
import BloquearData from "./partials/bloquearData.vue";

import { EdForm } from "@/components/common/form";

export default {
  name: "pageCadastroFuncao",
  props: {},
  components: {
    Parametro,
    CadastroGeral,
    BloquearHorario,
    BloquearData,
    EdForm,
  },
  provide() {
    return {
      bind: this.bind,
    };
  },
  mounted() {
    this.initialize();
  },
  created() {},
  data() {
    return {
      bind: {
        boolCarregado: false,
        arrayDiasAtendimento: [
          { intId: 0, strNome: "Domingo" },
          { intId: 1, strNome: "Segunda-Feira" },
          { intId: 2, strNome: "Terça-Feira" },
          { intId: 3, strNome: "Quarda-Feira" },
          { intId: 4, strNome: "Quinta-Feira" },
          { intId: 5, strNome: "Sexta-Feira" },
          { intId: 6, strNome: "Sábado" },
        ],
        arrayNumeroAgendamentoHora: [
          { intId: null, strNome: "Ilimitado" },
          { intId: 1, strNome: "1 por horário" },
          { intId: 2, strNome: "2 por horário" },
          { intId: 4, strNome: "4 por horário" },
          { intId: 6, strNome: "6 por horário" },
          { intId: 8, strNome: "8 por horário" },
          { intId: 10, strNome: "10 por horário" },
          { intId: 20, strNome: "20 por horário" },
        ],
        arrayDuracaoAtendimento: [
          { intId: null, strNome: "Selecione" },
          { intId: 10, strNome: "10 minutos" },
          { intId: 15, strNome: "15 minutos" },
          { intId: 20, strNome: "20 minutos" },
          { intId: 25, strNome: "25 minutos" },
          { intId: 30, strNome: "30 minutos" },
          { intId: 35, strNome: "35 minutos" },
          { intId: 40, strNome: "40 minutos" },
          { intId: 45, strNome: "45 minutos" },
          { intId: 50, strNome: "50 minutos" },
          { intId: 55, strNome: "55 minutos" },
          { intId: 60, strNome: "60 minutos" },
        ],
      },
      strTab: "tab-cadastro",
      strKey: this.$utilidade.randomString(),
      formData: {},
    };
  },
  watch: {},
  computed: {},
  methods: {
    initialize() {
      this.$root.$dialog.loading(true);

      Promise.all([
        this.$root.$request.get("Common/Parametro", {
          strChave: "agendamentoConfiguracao",
          boolBuscarSomenteAtivo: false,
        }),
      ]).then(([objConfiguracao]) => {
        this.$root.$dialog.loading(false);

        if (objConfiguracao.status == 200 && objConfiguracao.result) {
          if (!objConfiguracao.result.strValor) {
            objConfiguracao.result.strValor = {};
          }

          if (Number(objConfiguracao.result.strValor.strHorarioAtendimentoInicial)) {
            objConfiguracao.result.strValor.strHorarioAtendimentoInicial += ":00";
          }

          if (Number(objConfiguracao.result.strValor.strHorarioAtendimentoFinal)) {
            objConfiguracao.result.strValor.strHorarioAtendimentoFinal += ":00";
          }

          this.formData = {
            agendamentoConfiguracao: Object.assign(objConfiguracao.result, {}),
          };
        }

        this.bind.boolCarregado = true;
      });
    },

    salvar() {
      this.$root.$dialog.loading(true);

      this.$root.$request.post("Common/Parametro", this.formData).then((objResponse) => {
        this.$root.$dialog.loading(false);

        if (objResponse.status == 200) {
          (this.strKey = this.$utilidade.randomString()), this.initialize();
        }
      });
    },
  },
};
</script>
